import type {InitialNavigation} from '@angular/router';

export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyAtVDGmDVCwWunWW2ocgeHWnAsUhHuXvcg',
    authDomain: 'sign-mt.firebaseapp.com',
    projectId: 'sign-mt',
    storageBucket: 'sign-mt.appspot.com',
    messagingSenderId: '665830225099',
    appId: '1:665830225099:web:18e0669d5847a4b047974e',
    measurementId: 'G-1LXY5W5Z9H',
  },
  useFirebase: true,
  reCAPTCHAKey: '6Ldsxb8oAAAAAGyUZbyd0QruivPSudqAWFygR-4t',
  enableAppCheck: true, // Enable App Check
  initialNavigation: 'enabledBlocking' as InitialNavigation,
  // Clerk Authentication
  clerkPublishableKey: 'pk_test_YWxpdmUtd29sZi0yOC5jbGVyay5hY2NvdW50cy5kZXYk', // TODO: Replace with production key (pk_live_...) from Clerk Dashboard
  // YouTube Data API Key
  youtubeApiKey: 'AIzaSyCpfRYF51y2GX1IUWblDvo80nYny2V4vdk', // YouTube Data API v3 key
};
